import React from 'react';

import Heading from '@components/Heading';

const Quote = ({
  title = 'Why customers love it',
  quote = 'No more emailing CSVs of data or wasting time re-running the same query.',
  subtext = false,
  author = {
    name: 'Nico Bancel',
    position: 'Data Scientist',
    company: 'Instacart',
    thumbnail: '',
  },
  orientation = 'center',
  quoteSize = 'text-4xl lg:text-5xl',
  margin = 'mt-16 md:mt-32 md:mb-16 mx-auto',
  insertQuotes = true,
  readMoreUrl = false,
  avatar,
  logo,
  rawLogo,
}) => {
  return (
    <div
      className={`${
        orientation === 'center'
          ? `justify-center items-center`
          : `justify-start items-start`
      } ${margin}  fade fade-2 max-w-screen-lg w-full flex flex-col`}
    >
      {title && (
        <div
          className={`${
            orientation === 'center' ? `text-center` : ``
          } text-gray-800 mx-10 font-inter font-semibold text-sm mt-14 mb-10 z-10 uppercase fade fade-3`}
        >
          {title}
        </div>
      )}
      <div className="mx-10">
        <Heading
          Tag="h2"
          size="xs"
          className={`${
            orientation === 'center' ? `text-center` : ``
          } ${quoteSize} font-semibold`}
        >
          {insertQuotes && `"`}
          {quote}
          {insertQuotes && `"`}
        </Heading>
      </div>
      {subtext && (
        <div className="mx-10 my-4">
          <h3
            className={`${
              orientation === 'center' ? `text-center` : ``
            } text-gray-800 fade fade-1 z-10 relative font-inter font-medium`}
          >
            {subtext}
          </h3>
        </div>
      )}
      <div
        className={`${
          orientation === 'center' ? `text-center` : ``
        } flex flex-col lg:text-left lg:flex-row items-center mx-10 justify-between mt-8`}
      >
        <aside className="flex items-center">
          {!rawLogo && (
            <img
              className="w-16 rounded-full border-4 border-white border-solid lg:transform lg:translate-x-3"
              src={`${
                process.env.NEXT_PUBLIC_ASSET_HOST
              }/static/features/people/${author.name
                .toLowerCase()
                .replace(/\s/g, '-')}.png`}
              alt=""
            />
          )}

          {!rawLogo && (
            <img
              className="shadow-box rounded-xl"
              style={{
                boxShadow:
                  '0px 2.3245px 1.8596px rgba(0, 0, 0, 0.0196802), 0px 5.58609px 4.46887px rgba(0, 0, 0, 0.0282725), 0px 10.5181px 8.41448px rgba(0, 0, 0, 0.035), 0px 18.7625px 15.01px rgba(0, 0, 0, 0.0417275), 0px 35.0932px 28.0746px rgba(0, 0, 0, 0.0503198), 0px 84px 67.2px rgba(0, 0, 0, 0.07)',
              }}
              src={`${
                process.env.NEXT_PUBLIC_ASSET_HOST
              }/static/features/company/${author.company
                .toLowerCase()
                .replace(/\s/g, '-')}.svg`}
              alt=""
            />
          )}

          {avatar && (
            <img
              className="w-16 rounded-full border-4 border-white border-solid lg:transform lg:translate-x-3"
              src={avatar}
              alt=""
            />
          )}

          {logo && <img src={logo} className="w-16" alt="" />}
        </aside>
        <aside className="mt-6 lg:mt-0 lg:ml-8 font-inter flex-grow">
          <p className="text-black capitalize font-semibold">{author.name}</p>
          <p className="font-medium mb-2">
            {author.position}, {author.company}
          </p>

          {readMoreUrl && (
            <div
              className="font-inter font-semibold text-blue-100"
              href="#"
            >{`Read more ->`}</div>
          )}
        </aside>
      </div>
    </div>
  );
};

export default Quote;
